<script>

	import { onMount, getContext } from "svelte";
	import { get } from "svelte/store";
	import mapboxgl from 'mapbox-gl';

	import AppStore from "../AppStore"
	import MapStore from "../Map/Store"
	import GeoHelper from "../Helpers/GeoHelper"

	let map = MapStore.mapbox.instance;
	let geocoder = MapStore.mapbox.instanceGeocoder;

	onMount(() => {
		const inputElement = document.querySelector(".mapboxgl-ctrl-geocoder--input");
		const suggestionsElement = document.querySelector(".mapboxgl-ctrl-geocoder.mapboxgl-ctrl .suggestions-wrapper");
		const suggestionsUL = document.querySelector(".suggestions-wrapper .suggestions");
		const suggestionsErrorElement = document.querySelector(".mapbox-gl-geocoder--error");
		const clearSearchButton = document.querySelector(".mapboxgl-ctrl-geocoder--button"); // mapboxgl-ctrl-geocoder--pin-right
		// console.log("inputElement", inputElement);
		// console.log("suggestionsElement", suggestionsElement);
		// console.log("suggestionsUL", suggestionsUL);
		// console.log("suggestionsErrorElement", suggestionsErrorElement);
		// console.log("clearSearchButton", clearSearchButton);

		let lngLat = null;
		let inputString = "";
		let doClear = () => {
			suggestionsElement.style.display = "block";
			clearSearchButton.style.display = "none";
			lngLat = null;
			marker.remove();
		};
		let doFlyTo = () => {
			if (lngLat != null) {
				marker.setLngLat([lngLat[0], lngLat[1]]);
				marker.addTo($map);

				$map.flyTo({
					center: lngLat,
					offset: [AppStore.helpers.getMenuOffset() * 0.5, 0],
					speed: 0.5,
					curve: 2,
					zoom: 7
				});
				suggestionsElement.style.display = "none";
				clearSearchButton.style.display = "block";
			}
		}
		
		inputElement.attributes.getNamedItem("placeholder").value = "Location Search";

		let marker = new mapboxgl.Marker({ anchor: "center" });

		clearSearchButton.addEventListener('click', (e)=>{
			doClear();
		});

		inputElement.addEventListener('keyup', (e)=>{
			if (e.key === "Enter") {
				doFlyTo();
				e.preventDefault();

				let parseQ = GeoHelper._shouldStrBeParsedAsDMS(inputString);
				if (parseQ) {
					e.target.value = inputString;
					if ($geocoder.mapMarker) {
						console.log("removing geocoder", $geocoder);
						$geocoder.mapMarker.remove();
					}
				}


			}
		});
		inputElement.addEventListener('input', (e)=>{

			// console.log('input', e);
			let string = e.target.value;
			if (string.indexOf(",") !== -1) {
				let parts = string.split(",");
				if (parts.length === 2 && parts[0].length >= 1 && parts[1].length >= 1) {

					let coords = GeoHelper.parseStringLngLat(string);

					let lng = coords[0];
					let lat = coords[1];
					if (!isNaN(lat) && !isNaN(lng)) {

						suggestionsElement.style.display = "none";
						clearSearchButton.style.display = "block";

						console.log("it's a longlat!", lng, lat, lngLat);
						lngLat = GeoHelper.clampLngLat([lng, lat]);
						inputString = string;

						e.preventDefault();
					}
				}
			}
		});



	});
</script>
